import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {getPartialInvoiceCountReport} from "../../services/partialinvoice.services"

export const fetchPartialInvoiceCountReport = createAsyncThunk(
  "partialInvoiceCountReport/fetch",
  async (groupBy, { rejectWithValue }) => {
    try {
      const data = await getPartialInvoiceCountReport(groupBy);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const partialInvoiceCountSlice = createSlice({
  name: "partialInvoiceCountReport",
  initialState: {
    monthly: [], // Monthly partial invoice count data
    yearly: [], // Yearly partial invoice count data
    status: "idle", // idle | loading | succeeded | failed
    error: null, // Error message
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartialInvoiceCountReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPartialInvoiceCountReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (action.meta.arg === "month") {
          state.monthly = action.payload.monthly_invoice_count || [];
        } else if (action.meta.arg === "year") {
          state.yearly = action.payload.yearly_invoice_count || [];
        }
      })
      .addCase(fetchPartialInvoiceCountReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default partialInvoiceCountSlice.reducer;
